import "./RowField.css";

export default function RowField({children, nowrap}){
    return (
        <div className={"row-field" + (nowrap ? " nowrap" : "")}>
            {children}
        </div>
    );
}